import { Component, OnInit, Input, ContentChild, TemplateRef, Output, EventEmitter, PipeTransform, ViewChild } from '@angular/core';
import { BaseEntity } from '../../../models/baseEntity';
import { EntityContainer } from '../../../models/entityContainer';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
  selector: 'lean-datatable',
  templateUrl: './lean-datatable.component.html',
  styleUrls: ['./lean-datatable.component.scss']
})


export class LeanDatatableComponent implements OnInit {

  @ContentChild('rowDetail', { static: false }) rowDetailTmpl : TemplateRef<any>; 


  datePipe = new DatePipe('en-US');

  getRowClass(row : BaseEntity, column : any){
    let cls = '';
    if (row.deleted) {
      cls = 'deleted-row ';
    }

    if (column){
      cls += column.class;
    }
    return cls;
  } 

  getStyle(column : any){
    let stl = '';

    if (column.style){
      stl = column.style;
    }
    return stl;
  } 


  numbers       = [];
  _pageSize     : number = 10;


  @Input() entityContainer  : EntityContainer<BaseEntity> = new EntityContainer(BaseEntity); 
  @Input() expandable       : boolean       = false;
  @Input() noActions        : boolean       = false;
  @Input() noAddNew         : boolean       = false;
  @Input() rootRow          : BaseEntity    = null;
  @Input() columns          : any[];  
  @Input() set pageSize (psz : number){
    this._pageSize = +psz;
  }        
  @Input() rowCount         : number = -1;
  @Input() serverPageNumber : number;
  @Input() serverPageCount  : number;
  @Input() newButtonLabel   : string;
  

  
  _rows                     : BaseEntity[]  = [];
  //originalRows              : BaseEntity[]  = [];

  @Input() set rows(rs : []){
    if (! rs){
      rs = [];
    }
    this._rows = rs;
    this.tmpRows = rs;
   }



  @Output() onNew           = new EventEmitter<BaseEntity>();
  @Output() onSelect        = new EventEmitter<BaseEntity>();
  @Output() onSave          = new EventEmitter<BaseEntity>();
  @Output() onCancel        = new EventEmitter<BaseEntity>();
  @Output() onNextPage      = new EventEmitter<any>();
  @Output() onPreviousPage  = new EventEmitter<any>();

  startIndex  : number = 0;
  
  constructor(
    protected toastr : ToastrService,
    protected leanUtilsService : LeanUtilsService

    ) { }
 
  ngOnInit() {
  }

  getIcon(i : number) : string{
    if (this._rows[i].expand){
      return "assets/images/icons/shrink.png";
    } else {
      return "assets/images/icons/expand.png";
    }
}


  getNumbers() : number[]{

    let pageLength : number;
    
    if (this.rowCount != -1){
      pageLength = this.rowCount;
    } else {
      pageLength = this._pageSize;
    }

    this.numbers = [];
    for (let i = this.startIndex; i< this.startIndex +  pageLength; i++){
      if (i >= this._rows.length){
        break;
      }
      this.numbers.push(i);
    }
    return this.numbers;
  }


  first(){
    this.startIndex = 0;
  }
  last(){
    this.startIndex = this._rows.length - this._pageSize;
    if (this.startIndex  < 0){
      this.startIndex = 0;
    }
  }

  next(){
    if (this.startIndex + this._pageSize >= this._rows.length){
      return;
    }
    this.startIndex += this._pageSize;
  }

  previous(){
    this.startIndex -= this._pageSize;
    if (this.startIndex  < 0){
        this.startIndex = 0;
    }
  }

  nextPage(){
    this.onNextPage.emit(null);
  }
  previousPage(){
    this.onPreviousPage.emit(null);
  }


  toggleExpand( i : number){
    this._rows[i].expand = !  this._rows[i].expand ;
  }

  edit(index : number){
    this._rows[index]._original = { ...this._rows[index] };
    this._rows[index].edit = true;
    if ( ! this._rows[index].inserted){
      this._rows[index].deleted = false;
      this._rows[index].updated = true;
    }

  }

  delete(index : number){  
    this._rows[index].inserted = false;
    this._rows[index].deleted = true;
    this._rows[index].updated = false;
  }


  cancel(index : number){
    if ( this._rows[index].deleted) {
      this._rows[index].deleted = false;
      return;
    } 
    
    this._rows[index].edit = false;
    this._rows[index] = this._rows[index]._original;  // this.originalRows[index];
    this.onCancel.emit(this._rows[index]);
  }

  
  saveNewRow(){
    for (let column of this.columns){
      if (column.required){
        let value = this.getJsonProp(this.entityContainer.row, column);
        if ((value == null) || (value == undefined)){
            let message = "Le champ : [" + column.name + "] ne peut pas être null";
            this.toastr.error(message);
            return;
        }
      }
    }
    this.entityContainer.row.inserted = true;
    this.entityContainer.row.deleted = false;
    this.entityContainer.row.updated = false;
    this.onSave.emit(this.entityContainer.row);
  } 


  save(index : number){
    this.onSave.emit(this._rows[index]);
  }


  select(index : number){
    this.onSelect.emit(this._rows[index]);
  }


  selectNewRow(){
    if (this.onNew){
      this.onNew.emit(null);
      return;
    }

    this.entityContainer.row.inserted = true;
    this.entityContainer.row.deleted = false;
    this.entityContainer.row.updated = false;
    this.onSelect.emit(this.entityContainer.row);
  }

   getJsonProp(row, column) {

    if (!row) {
      return '';
    }

    if (column.lov){
      let value = null;
      let keyValue = null;
      
      if (column.key){
        keyValue = row[column.prop][column.key];
      } else {
        keyValue = row[column.prop];
      }

      for (let d of column.lov.data){
        if (d[column.lov.key] == keyValue){
          value = d[column.lov.value];
          break;
        }
      }
      return value;
    }

     let props = column.prop;
      const args = props.split('.');
      let cur = row;
      for(let i=0;i<args.length;i++){
          cur = cur[args[i]];
          if (! cur){
            break;
          }
      }

      if (column.type == 'date'){
        cur = this.datePipe.transform(cur, 'dd/MM/yyyy');
      }
      if (column.type == 'time'){
        cur = this.datePipe.transform(cur, 'HH:mm');
      }
      if (column.type == 'dateTime'){
        cur = this.datePipe.transform(cur, 'dd/MM/yyyy HH:mm');
      }
      return cur;
    }

    
    getChecked(obj, column) : string{
      let imagePath : string = "assets/images/icons/unchecked.png";
      let value = this.getJsonProp(obj, column);
      if (value){
        imagePath = "assets/images/icons/checked.png";
      } 
      return imagePath;
    }


    imgLabel: string = "Choose file...";
    setImage(row: BaseEntity, column, input : HTMLInputElement) {
      let files: FileList = input.files
        this.getBase64(files[0]).then( result =>{
          row[column.prop] = result;
          input.value = "";
        });


        // then the call to post method as normal...
    }

    getBase64(file): Promise<any> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader(); // to read the content of the file asynchronously !
            const reader2 = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
   //---------------------------------------------------------------------------------------------
   //---------------------------------------------------------------------------------------------



  //---------------------------------------------------------------------------------------------
  showColumnModal(row : BaseEntity, column : any){
      const fieldName = column.prop.split('.')[0];
      column.modal.show(row, fieldName);
    }
  //---------------------------------------------------------------------------------------------

  hasLogo(column) {
      // return /.\logo/.test(column.prop);
      const regex = /\.logo/
      return regex.test(column.prop);
  }
  tmpRows = [];
  searchTerm: string = "";
  noResultAfterFiltering: boolean = false;
  searchByFilter(column) {
      this.noResultAfterFiltering = false;
      this.searchTerm = this.searchTerm.toLowerCase();
      this.tmpRows = this._rows.filter(row => {
          return this.getJsonProp(row, column).toLowerCase().indexOf(this.searchTerm) != -1;
      });
      this.noResultAfterFiltering = (this.tmpRows.length === 0);
  }

  enableFilter(column) {
      column.filterEnabled = true;
      for (let col of this.columns) {
          if (column.prop != col.prop) {
              col.filterEnabled = false;
          }
      }
  }

  closeFilter(column, event?) {
      column.filterEnabled = false;
  }

  sortByColumnValue(column) {
      this.tmpRows.sort((rowA, rowB) => {
          const a = this.getJsonProp(rowA, column);
          const b = this.getJsonProp(rowB, column);
          if (typeof a == "string") {
              if(a < b) return -1;
              else if (a > b) return 1;
              else return 0;
          }
          if (typeof a == "number") {
              return a - b;
          }
          // we should add the other types like dates ...
      });
  }
  //---------------------------------------------------------------------------------------------
  


    /*

    getJsonNgModel(index, column) {
      let res =  '_rows[' + index + '].'+column.prop;
      return res;
    }
    qtd(index, attr) {return '_rows[0].name'}

    pp = '_rows[0].name';

    */
 }

